// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__NOKCH","fixed":"Modal_fixed__vrirT","contents":"Modal_contents__VNlkT"};